var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"stroke-color",attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#055A7F","stroke-linecap":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M6.188 12.625h12.374M12.375 6.438v12.374"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }